// src/constants/cartConstants.js
export const WISHLIST_ADD_ITEM = "WISHLIST_ADD_ITEM";
export const WISHLIST_REMOVE_ITEM = "WISHLIST_REMOVE_ITEM";
export const WISHLIST_CLEAR_ITEMS = "WISHLIST_CLEAR_ITEMS";
export const WISHLIST_RESET_FLAGS = "WISHLIST_RESET_FLAGS";
